"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actions = {
    TRACK_REQUESTED_EVENTS: 'TRACK_REQUESTED_EVENTS',
    FETCH_EVENTS: 'FETCH_EVENTS',
    PUT_EVENTS: 'PUT_EVENTS'
};
exports.actionCreators = {
    trackRequestedEvents: (ids) => ({
        type: exports.actions.TRACK_REQUESTED_EVENTS,
        ids
    }),
    fetchEvents: (ids) => ({
        type: exports.actions.FETCH_EVENTS,
        ids
    }),
    putEvents: (events) => ({
        type: exports.actions.PUT_EVENTS,
        events
    })
};



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-website-store/events/actions.ts